module.exports = __webpack_public_path__ + "media/images/map/time-a72b7f99577893ae21d6ae68aeaa0f9a.svg";